import { FC } from 'react';
import { Modal } from 'antd';
import { observer } from 'mobx-react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { AddressWarningModalStyles } from './AddressWarningModal.styles';
import { EPButton } from '@/components';
import { useStores } from '@/hooks/use-stores';

interface AddressWarningModalProps {
  visible: boolean;
  onProceed: () => void;
  onCancel: () => void;
}

const AddressWarningModal: FC<AddressWarningModalProps> = observer(({ visible, onProceed, onCancel }) => {
  const { siteSurveyStore } = useStores();
  const { t } = useTranslation();

  const displayRegion = siteSurveyStore.selectedRegion;

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      centered
      width={420}
      title={null}
      closable={true}
      maskClosable={false}
    >
      <AddressWarningModalStyles>
        <div className="address-warning-modal-content">
          <div className="address-warning-icon">
            <ExclamationCircleOutlined />
          </div>
          <div className="address-warning-title">{t('addressNotInserted')}</div>
          <div className="address-warning-description">
            {t('addressNotInsertedWarning', { siteRegion: displayRegion })}
          </div>
          <div className="address-warning-actions">
            <EPButton onClick={onCancel}>{t('Cancel')}</EPButton>
            <EPButton type="primary" onClick={onProceed}>
              {t('Proceed')}
            </EPButton>
          </div>
        </div>
      </AddressWarningModalStyles>
    </Modal>
  );
});

export default AddressWarningModal;
